import React from 'react'
import './Button.css'

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'edit' | 'delete' | 'cancel' | 'back'
}

export const Button: React.FC<ButtonProps> = ({
  variant = 'primary',
  children,
  className,
  ...props
}) => {
  const base = 'btn'
  const classes = [base, `btn-${variant}`, className].filter(Boolean).join(' ')
  return (
    <button className={classes} {...props}>
      {variant === 'back' && (
        <img
          src={'/icons/back-to-page-icon.svg'}
          alt={'Back to previous page Icon'}
        />
      )}
      {children}
    </button>
  )
}
